import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => (
  <footer className="app-footer">
    <span>© {new Date().getFullYear()} Tomitty</span>
    <div className="footer-links">
      <Link component={RouterLink} to="/service-description" color="inherit">サービスについて</Link>
      <Link component={RouterLink} to="/legal-information" color="inherit">特定商取引法に基づく表記</Link>
      <Link component={RouterLink} to="/privacy-policy" color="inherit">プライバシーポリシー</Link>
    </div>
  </footer>
);

export default Footer;
